import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IUser } from '@/api/routes/users/types';

import { fetchCurrentUser } from './actionCreators';

interface InitialState {
  user: IUser | null,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  user: null,
  isLoading: false,
  error: '',
};

export const currentUserSlice = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    removeCurrentUser: (state) => {
      state.user = null;
    },
  },
  extraReducers: {
    [fetchCurrentUser.fulfilled.type]: (state, action: PayloadAction<IUser>) => {
      state.isLoading = false;
      state.error = '';
      state.user = action.payload;
    },
    [fetchCurrentUser.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchCurrentUser.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { removeCurrentUser } = currentUserSlice.actions;
export default currentUserSlice.reducer;
